const validation = {
    methods: {
        validateNotEmpty(value) {
            // eslint-disable-next-line fp/no-this
            if (this.isEmpty(value)) {
                return null;
            }
            return value.length > 0;
        },
        isEmpty(value) {
            return value === null || value === undefined;
        },
        getStateForComponentValidation(meta) {
            if (!meta.validated)
                return null;
            if (meta.touched || meta.dirty) {
                return meta.valid;
            }
            const isInvalid = meta.validated && !meta.valid;
            return isInvalid ? false : null;
        },
        getStateForComponentValidationWithClickButton(meta, isContinueButtonClicked) {
            // please be aware: This function is migrated without beein able
            // to approve its working as expected
            // please check whether this works when migrating the actual form wizard:
            // zf/frontend/administration/pages/viiu
            // /components/userDefinedAlarms/comparisonModal/UserDefinedAlarmComparisonModal.vue
            if (!meta.validated)
                return null;
            if (meta.valid === false && isContinueButtonClicked === false)
                return null;
            if (meta.touched || meta.dirty) {
                return meta.valid;
            }
            const isInvalid = meta.validated && !meta.valid;
            return isInvalid && isContinueButtonClicked ? false : null;
        },
    },
};
export default validation;
